// Web stand-in for Flutter HapticFeedback (spec 01 §15.3.14, 05 §9.5).
// Android browsers vibrate; iOS Safari has no vibration API, so this is a no-op there.

export type HapticKind = 'selection' | 'light' | 'medium' | 'heavy';

const PATTERN_MS: Record<HapticKind, number> = { selection: 5, light: 8, medium: 10, heavy: 20 };

export function haptic(kind: HapticKind = 'light'): void {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  try {
    navigator.vibrate(PATTERN_MS[kind]);
  } catch {
    // Vibration can be blocked (no user activation, permissions policy); feedback is optional.
  }
}
